import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Button, Chip, Icon, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { EditButton } from "../../../../../components/mui/Buttons/Buttons";
import {
  CloseLedger,
  getLedgerData,
  updateCroNotes,
} from "../../../../../redux/features/CRDslice";

const CloseAccounts = ({
  data,
  studentName,
  admissionNo,
  course,
  closingBalance,
  courseEnrollmentId,
  month,
  year,
  totalExpense,
  totalIncome,
  openingBalance,
  dispatchdata,
}) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.crd);

  const date = new Date(year, month - 1);
  const formattedDate = date.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });

  const nextdate = new Date(year, month);
  const nextmonth = nextdate.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      remarks: "",
      course_enrollment_id: courseEnrollmentId,
      month: month,
      year: year,
      closingBal: closingBalance,
    },
    onSubmit: (values) => {
      dispatch(CloseLedger(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getLedgerData(dispatchdata));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Close Accounts"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          sx={{
            backgroundColor: "#00b4d8",
            color: "#fff",
            px: 2,
            "&:hover": {
              backgroundColor: "#0077b6",
              color: "#fff",
            },
          }}
          onClick={() => setOpen(true)}
        >
          Close Accounts
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={1} paddingBottom={2}>
                  <Chip
                    label={`Student :  ${studentName} (${admissionNo}) - ${course}`}
                    variant="outlined"
                  />
                  <Chip
                    label={`Month & Year : ${formattedDate}`}
                    variant="outlined"
                  />
                  <Chip
                    label={`Opening Balance : ${openingBalance}`}
                    variant="outlined"
                  />
                  <Chip
                    label={`Total Income : ${totalIncome}`}
                    variant="outlined"
                  />
                  <Chip
                    label={`Total Expense : ${totalExpense}`}
                    variant="outlined"
                  />
                  <Chip
                    label={`Closing Balance : ${closingBalance}`}
                    variant="outlined"
                  />
                </Stack>
                <Stack direction={"column"} spacing={1} paddingBottom={2}>
                  <Chip
                    label={`Opening Balance : ${closingBalance}`}
                    color="primary"
                    variant="outlined"
                  />
                  <Chip
                    label={`Next Month & Year : ${nextmonth}`}
                    color="primary"
                    variant="outlined"
                  />
                </Stack>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    fullWidth
                    label="Remarks"
                    name="remarks"
                    multiline
                    rows={2}
                    value={formik.values.remarks}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.remarks && Boolean(formik.errors.remarks)
                    }
                    helperText={formik.touched.remarks && formik.errors.remarks}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Close Accounts"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CloseAccounts;
